import { useState } from 'react'

import { useMe } from '@/providers'
import { Box, Slide, Stack, Typography } from '@mui/material'
import { buildEnv, isApiLocal } from '@utils/EnvironmentHelper'
import { getEnvColor } from '@utils/helpers'
import { titleCase } from 'title-case'

const styles = {
	container: {
		position: 'fixed',
		top: 0,
		left: '50%',
		transform: 'translateX(-50%)',
		zIndex: (theme) => theme.zIndex.drawer + 100,
	},
	env: (color) => ({
		backgroundColor: color,
		py: 0.5,
		px: 3,
		boxShadow: (theme) => theme.shadows[5],
		borderBottomLeftRadius: 4,
		borderBottomRightRadius: 4,
	}),
}

export default function Environment() {
	const [isShown, setIsShown] = useState(true)

	const { roles } = useMe()

	if (buildEnv === 'production') return null

	const color = getEnvColor()

	return (
		<Box
			onMouseEnter={() => setIsShown(false)}
			onMouseLeave={() => setIsShown(true)}
			sx={styles.container}
			data-testid="environment"
		>
			<Slide in={isShown} direction="down">
				<Stack alignItems="center" sx={styles.env(color)}>
					<Typography
						noWrap
						variant="body1"
						component="span"
						color={`${color}.dark`}
						fontWeight="normal"
					>
						{titleCase(buildEnv)} - {roles.map((role) => role.displayName).join(', ')}{' '}
						{isApiLocal ? ' (Local API)' : ''}
					</Typography>
				</Stack>
			</Slide>
		</Box>
	)
}
